import axios from 'axios';
import { http } from '../../index';

// 请求到的数据返回
export interface NetworkResponse {
  type: string;
  data: any;
}

// 网络请求
const methods = {
  request(inPayLoad: any = {}): Promise<NetworkResponse> {
    const {
      cmdId,
      data,
      headerType = 2,
      paramType = 0,
      isApiV2 = false,
      inHeaders,
      showError = false,
      headers = {},
    } = inPayLoad;

    let url = '/v1';
    if (Number(cmdId) === 371138) {
      url = '/v3';
    } else if (isApiV2) {
      url = '/v2';
    }

    return http.post<any>(url, data, {
      headers: {
        ...headers,
        cmdId,
        headerType,
        paramType,
        tid: inHeaders?.Tid ?? inHeaders?.tid,
        showError,
      },
    });
  },
  /**
   * @description 获取指定URL的内容(get方式)
   * @payload @requires payload.url 要请求的网页的地址
   */
  getContent(payload: Record<string, any>) {
    return axios({
      method: 'get',
      url: payload.url,
      timeout: 120000,
      headers: payload.headers ? payload.headers : {},
    });
  },
};

export default methods;
